import React from 'react';
import { useWebContents } from '../../hooks/useWebContents';
import ServiceCard from '../../customized/ImageContentPair';
import { useImages } from '../../hooks/useImages';

const GUIDS = {
  foodScrapPickups: '91cb5417-347e-4da6-8193-0d72419c1553',
  services: '150290a7-b38d-40b8-8393-f2fdd455d9ae',
  benefitsOfCompost: 'a09f95b2-64ae-4911-bdd5-9cdb333ba0a4',
};

const ServicesSection: React.FC = () => {
  const contents = useWebContents(GUIDS, 'Home');

  const foodScrapImage = useImages(GUIDS.foodScrapPickups);
  const servicesImage = useImages(GUIDS.services);
  const benefitsOfCompostImage = useImages(GUIDS.benefitsOfCompost);

  const services = [
    {
      title: contents.foodScrapPickups.heading,
      img: foodScrapImage?.image,
      bgColor: "bg-[#28311B]",
      description: contents.foodScrapPickups.content,
    },
    {
      title: contents.services.heading,
      img: servicesImage?.image,
      bgColor: "bg-[#AE582D]",
      description: contents.services.content,
      button: (
        <a
          href="#signUp"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 bg-white text-[#AE582D] px-14 py-4 rounded-xl hover:bg-[#d78b65] transition-colors text-base font-semibold text-[18px]"
        >
          Sign up!
        </a>
      ),
    },
    {
      title: contents.benefitsOfCompost.heading,
      img: benefitsOfCompostImage?.image,
      bgColor: "bg-[#96B071]",
      description: contents.benefitsOfCompost.content,     
    },
  ];

  return (
    <section className="w-full py-12 flex flex-col items-center">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-y-4 md:gap-x-4 gap-x-2 w-full max-w-7xl px-4">
        <h3 className="col-span-full text-2xl md:text-5xl font-bold text-[#AE582D] mb-6 text-center ">
          MAKING A DIFFERENCE
        </h3>
        {services.map((service, idx) => (
          <ServiceCard
            key={service.title + idx}
            title={service.title}
            img={service.img ?? ""}
            bgColor={service.bgColor}
            description={service.description}
            button={service.button}
          />
        ))}
      </div>
    </section>
  )
};

export default ServicesSection;